<template>
    <div class="d-flex flex-row flex-wrap justify-content-center p-1">
        <b-button
            :id="`btn-enps-${option.id}-comments`"
            variant="link"
            class="nav-item mr-4"
            :key="enpsStatus"
            :pressed="model == enpsStatus"
            v-for="(option, enpsStatus) in options"
            @click="onChange(enpsStatus)"
        >
            <span>{{ option.title }}</span>
        </b-button>
    </div>
</template>
<script>
export default {
    props: {
        model: {
            type: String,
            required: true,
        },
    },
    data() {
        return {}
    },
    methods: {
        onChange(status) {
            this.$emit('update:model', status)
            this.$emit('change', status)
        },
    },
    computed: {
        options() {
            return {
                promoters: {
                    id: 'promoters',
                    title: 'Promotores',
                },
                neutral: {
                    id: 'neutral',
                    title: 'Neutros',
                },
                detractors: {
                    id: 'detractors',
                    title: 'Detratores',
                },
            }
        },
    },
}
</script>
<style lang="sass" scoped>
$primary-color: #20a8d8
$border-bottom: 2px solid $primary-color

.nav-item
    color: #808080
    font-size: 15px
    font-weight: 600
    text-decoration: none
    border: 2px solid transparent

.active,
.nav-item:hover,
.nav-item:focus,
.nav-item:active
    color: $primary-color
    border-bottom: $border-bottom

.nav-item:disabled
    cursor: progress !important
</style>
